// extracted by mini-css-extract-plugin
module.exports = {"card":"SimpleDataCard_card__26QeO"};